import { ChooseLanguage } from "./chooseLanguage";
import { MultilingualContent } from "./multilingualContent";
import { useParse, useTranslation } from "@refinedev/core";
import { CreateEventStep, IEventDetail, UserType } from "interfaces";
import { Link } from "react-router-dom";
import Button from "components/button";
import { EventInfo } from "./eventInfo";
import { CollapsibleSection } from "components/collapsibleSection";
import { EventSection } from "./eventSection";
import { TicketOnSale } from "./ticketOnSale";
import { InternalSetup } from "./internalSetup";
import { canAccessByType } from "utills/helpers";

export const ViewBuildEventPageStep = (props: {
  eventDetailData?: IEventDetail;
}) => {
  const { eventDetailData } = props;
  const parse = useParse();
  const { params } = parse();

  if (params?.id) {
    return eventDetailData ? <BuildEventPageStepForm {...props} /> : <></>;
  }
  return <BuildEventPageStepForm {...props} />;
};

export const BuildEventPageStepForm = ({
  eventDetailData,
}: {
  eventDetailData?: IEventDetail;
}) => {
  const { translate } = useTranslation();
  return (
    <div className="flex flex-col gap-y-4 sm:gap-y-6">
      <CollapsibleSection label={translate("eventSetup.eventInfo.section.chooseEventLanguage")}>
        <ChooseLanguage eventDetailData={eventDetailData} />
      </CollapsibleSection>
      <CollapsibleSection label={translate("eventSetup.eventInfo.section.multilingualContent")}>
        <MultilingualContent eventDetailData={eventDetailData} />
      </CollapsibleSection>
      <CollapsibleSection label={translate("eventSetup.eventInfo.section.addEventInfo")}>
        <EventInfo eventDetailData={eventDetailData} />
      </CollapsibleSection>
      <CollapsibleSection label={translate("eventSetup.eventInfo.section.addMoreSection")}>
        <EventSection eventDetailData={eventDetailData} />
      </CollapsibleSection>
      <CollapsibleSection label={translate("eventSetup.eventInfo.section.ticketSalePeriod")}>
        <TicketOnSale eventDetailData={eventDetailData} />
      </CollapsibleSection>
      {canAccessByType(UserType.ADMIN) ? (
        <CollapsibleSection label="Internal Setup">
          <InternalSetup eventDetailData={eventDetailData} />
        </CollapsibleSection>
      ) : <></>}
      <div
        className="w-full px-4 py-4 sm:px-6 bg-white sticky bottom-0 z-[2]"
        style={{ boxShadow: "rgba(0, 0, 0, 0.23) 0px -5px 5px -5px" }}
      >
        <div className="flex items-center justify-end gap-x-4">
          <Link to={`/events/sports`}>
            <Button className="min-w-20 bg-white text-brand-500 border border-solid border-brand-500 hover:bg-gray-50 active:bg-gray-100">
              {translate("button.cancel")}
            </Button>
          </Link>
          <Link to={`/events/sports/${eventDetailData?.id}?step=${CreateEventStep.PARTICIPANT_TEMPLATE}`}>
            <Button className="min-w-20" type="submit">
              {translate("button.next")}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
